<template>
	<form @submit.prevent="onSubmit">
		<role-select
			v-model="form.role"
			name="role"
		/>
		<smart-input
			v-model="form.name"
			:errors="inputErrors.name"
			label="name"
		/>
		<smart-input
			v-model="form.email"
			:errors="inputErrors.email"
			label="email"
		/>
		<smart-input
			v-model="form.password"
			:errors="inputErrors.password"
			label="password"
		/>

		<div class="form-group">
			<v-btn
				type="submit"
				:loading="inProgress"
				color="success"
			>
				שמירה
			</v-btn>
		</div>
	</form>
</template>

<script>
	import UserModule from "src/store/modules/User.module";
	import FormView from "src/mixins/FormView";
	import RoleSelect from "./RoleSelect";

	export default {
		name: "user-form",
		components: { RoleSelect },
		props: [],
		data () {
			return {
				form: {
				},
			};
		},
		mixins: [new FormView(UserModule, "user")],
		computed: {
			isNew () {
				return !this.user.id;
			},
		},
	};
</script>
